module.exports = __webpack_public_path__ + "static/img/Permiso(9).408650a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fotografias/Permiso(9).jpg
// module id = LYuZ
// module chunks = 0